<template>
   <div class="container">
	<div class="sidebar">
	    <my-component></my-component>
	  </div>
    <div class="content">
	     <div class="block">
      <div class="page-header">
       最近区块</div>
      <div
        class="mobile_cell"
        v-for="(item, index) in tableData"
        :key="index + ''"
      >
        <van-cell-group :border="false">
          <van-cell title="区块高度" :value="item.height" :border="false">
            <template>
              <router-link
                style="text-decoration: none"
                :to="{
                  path: '/blockDetail',
                  query: { height: item.height },
                }"
                >{{ item.height }}
              </router-link>
            </template>
          </van-cell>
          <van-cell title="区块哈希" :value="item.block_hash" :border="false">
            <template>
              <router-link
                style="text-decoration: none"
                :to="{
                  path: '/blockDetail',
                  query: { height: item.height },
                }"
                >{{ item.block_hash }}
              </router-link>
            </template>
          </van-cell>
          <van-cell title="生成日期"  :border="false" >{{item.time |timeformat}}</van-cell> 
        </van-cell-group>
      </div>
    
    
 
  </div>
  <div class="paginations" >
        <el-pagination
    	v-model="currentPage"
          @current-change="getPage"
          :page-size="5"
          :total="100"
          :pager-background="true"
          :background="true"
          layout="prev, pager, next"
        >									
        </el-pagination>
    </div>
  </div>
  </div>
</template>
<script>
	import MyComponent from '@/components/MyComponent.vue';
export default {  components: {  MyComponent },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      blockData: [],
      tableData: [],
    };
  },
  filters: {
    timeformat(val) {
      if (val && typeof val == "string") {
        return val.substring(0, val.indexOf("."));
      }
    },
  },
  mounted() {
    this.getBlockTable();
    this.timer = window.setInterval(() => {
      setTimeout(this.getBlockTable(), 0);
    }, 3000);
  },
  methods: {
    getBlockTable() {
      this.$http
        .get(`${block_ip}blocks/${this.currentPage}/${this.pageSize}`)
        .then((res) => {
          let data = res.data.data;
          if (data) {
            this.tableData = data;
          }
        });
    },
    getPage(value) {
      this.currentPage = value;
      this.getBlockTable();
    },
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="scss" scoped>
.mobile_cell {
  background-color: rgb(37,49,63);
  border: none;
  padding:10px;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

.search-icon {
  font-size: 16px;
  line-height: inherit;
}
.van-cell__value {
  flex: 3;
}
.van-cell__value {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.van-cell {
  padding: 10px 16px 10px 16px;
  background-color: rgb(26,35,45);
  color:white;

}

.block {
  margin: 0 12px;
  background-color:rgb(26,35,45);
}
.paginations {
  margin: 0 12px;
  width:300px;
  margin-left: 35%;
}
.page-header {
  padding: 15px; /* 根据需要调整内边距 */
  background-color: rgb(37,49,63); /* 背景颜色 */
  position: relative; /* 相对定位，如果需要定位子元素 */
  font-size:20px;
  color:white;
  font-weight:bold;
}
.container {
	  display: flex;
	  min-height: 100vh;
	}
	
	.sidebar {
	  flex:1;
	  height: 100vh; /* 侧边栏高度 */
	  
	}
	
	.content {
	  flex:9;
	  padding: 20px; /* 内容区域的内边距 */
	  background-color: rgb(37,49,63);
	}
	a {
	  color: white ; /* 设置链接的颜色为黑色 */
	  text-decoration: none; /* 移除下划线 */
	}
</style>
